import { useState, useContext } from 'react'
//import avatar from '../../img/profile.png'
import { MyContext } from "../../context";
import supabase from "../../Supa";


import axios from 'axios';

//const ServerUrl = "http://localhost:3001/uploads/"
const ServerUrl = "https://ig3n-api.onrender.com/uploads/"


function Uploading() {

    const { updateuserId, updateProfile_url, userId, Profile_url} = useContext(MyContext);

    /* 
    const UserIdLocal =  window.localStorage.getItem("User");
    const data = JSON.parse(UserIdLocal)

   if(userId === ""){
        
       // updateuserId(data._id)

        console.log("upload | user_id is empty")

    } */


  const [postImage, setPostImage] = useState( {UserId: userId, url : ""})
  const [buttonDisable, setButtonDisable] = useState(false)

    //supabase
    async function updateImg(e) {
        try {
            const { data, error } = await supabase
                .from("UserTicket")
                .update({
                  Image: e,
                })
                .eq("User_id", userId);

               // console.log("Supa url uploaded")
            } catch (error) {
              console.log(error);
            }
        }
        
        //end supabase

  const createPost = async (newImage) => {
    try{
      await axios.put(ServerUrl, newImage).then((response) => {

       if(response.status === 200){
        updateImg(response.data[0])
        localStorage.setItem("UserImg", JSON.stringify(response.data[0]));
        updateProfile_url(response.data[0])
        setButtonDisable(false)
       }
        
        
      })
    }catch(error){
      console.log(error)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonDisable(true)
    createPost(postImage)
  //  console.log("Uploaded")
  }

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
  //  console.log(base64)
    setPostImage({ UserId: userId, url : base64 })
   
  }

  return (
    <>
    <div className="App">
      <form onSubmit={handleSubmit}>

        <label htmlFor="file-upload" className='custom-file-upload'>
          <img src={postImage.url || Profile_url} style={{width:"450px"}} alt="" />
        </label>

        <input 
          type="file"
          lable="Image"
          name="myFile"
          id='file-upload'
          accept='.jpeg, .png, .jpg'
          onChange={(e) => handleFileUpload(e)}
         />
        {buttonDisable?  <button type='submit' disabled>Submit</button> : <button type='submit'>Submit</button>}
        
      </form>
    </div>
    
    </>
  )
}

export default Uploading

function convertToBase64(file){
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result)
    };
    fileReader.onerror = (error) => {
      reject(error)
    }
  })
}

